import { KiteIcon } from '@kite/react-kite';
import React, { useEffect, useRef, useState } from 'react';
import { ParentNodeProvider } from '../../../providers/ParentNodeProvider';
import { onClickEventTracker } from '../../../shared/analytics/callAnalytics';
import {
    EventName,
    TrackedParentNode,
    UserInteractionEvent,
    UserInteractionType,
} from '../../../models/GTMEventTypes';
import { stripHTMLStrings } from '../../../shared/stripHtml';
import resolvePath from '../../../shared/resolvePath';
import './PromoBar.scss';

export interface PromoBarInputs {
    text: string;
    header: string;
}

export const PromoBar = ({ promoBar }) => {
    const [expanded, setExpanded] = useState(true);
    const getLinkHref = (htmlText: string) => htmlText.split(`"`)[1];

    // Populate meta data for tracking the user interaction event
    const eventAnalytics: UserInteractionEvent = {
        event: EventName.USER_INTERACTION,
        event_data: {
            type: UserInteractionType.LINK_CLICK,
            component_name: stripHTMLStrings(promoBar.text),
            component_type: `Internal Link`,
            parent_name: undefined,
            parent_type: `Promo_Bar` as TrackedParentNode,
            current_path: resolvePath(),
            next_path: getLinkHref(promoBar.text),
        },
    };

    useEffect(() => {
        const t = setTimeout(() => {
            setExpanded(false);
        }, 10000);

        return () => {
            clearTimeout(t);
        };
    }, [expanded]);

    return (
        <ParentNodeProvider nodeName={undefined} nodeType="Promo_Bar">
            <header
                onFocus={() => setExpanded(true)}
                className={`promo-bar ${expanded ? `expanded` : ``}`}
            >
                <div className="kite-container">
                    <h3>
                        <span>
                            {promoBar.header}
                            <KiteIcon size="1rem" icon="ki-chevron-down" />
                        </span>
                        {!expanded && (
                            <button
                                aria-expanded={false}
                                aria-label="View details"
                                onClick={() => setExpanded(true)}
                            ></button>
                        )}
                    </h3>
                    <div
                        className="secondary"
                        onClick={(e) => onClickEventTracker(e, eventAnalytics)}
                        dangerouslySetInnerHTML={{ __html: promoBar.text }}
                    ></div>
                </div>
                {expanded && (
                    <button
                        aria-label="Hide details"
                        aria-expanded={true}
                        onClick={() => setExpanded(false)}
                    >
                        <KiteIcon icon="ki-x" />
                    </button>
                )}
            </header>
        </ParentNodeProvider>
    );
};
